import isFunction from 'lodash/isFunction';

class ClickableIconCtrl {
    iconClicked() {
        if (isFunction(this.clickCallback)) {
            this.clickCallback();
        }
    }
}

export default ClickableIconCtrl;